import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import { MuiThemeProvider } from "@material-ui/core/styles";
import theme from "./config/theme";
import { SnackbarProvider } from "notistack";

import {
  StylesProvider,
  createGenerateClassName,
} from "@material-ui/core/styles";

import { StoreContext } from 'storeon/react'
import store from "./store";

import CssBaseline from "@material-ui/core/CssBaseline";

if(window.location.hostname === 'www.deskpad.de' ||
   window.location.hostname === 'staging.deskpad.de'
  ){
  Sentry.init({
    dsn: "https://bc5966801eae499a8ccdce0692cd70b1@sentry.svix.de/2",
    integrations: [
      new Integrations.BrowserTracing(),
    ],
    beforeSend(event, hint) {
      // Check if it is an exception, and if so, show the report dialog
      if (event.exception) {
        Sentry.showReportDialog({lang:'de', eventId: event.event_id });
      }
      return event;
    },

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

const generateClassName = createGenerateClassName({
  productionPrefix: "dpe"
});

// Couldn't find proper option to set offset for snackbars, so proprety was overrided
(function() {
  const offsetTopBottom = window.innerWidth > 480 ? 118 : 32;
  Object.defineProperty(SnackbarProvider.prototype, "offsets", {
    get: function() {
      const { snacks } = this.state;
      return snacks.map((item, i) => {
        let index = i;
        const { view: viewOffset, snackbar: snackbarOffset } = this.props.dense
          ? { view: 0, snackbar: 4 }
          : { view: offsetTopBottom + 32, snackbar: 12 };
        let offset = viewOffset;
        while (snacks[index - 1]) {
          const snackHeight = snacks[index - 1].height || 48;
          offset += snackHeight + snackbarOffset;
          index -= 1;
        }
        return offset;
      });
    }
  });
})();

//FIXME: move it to separate file and do not extend native
// eslint-disable-next-line
Number.prototype.toDPEFormat = function(val) {
  return this.toLocaleString("de", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

window.store = store;

ReactDOM.render(
  <StoreContext.Provider value={store}>
    <CssBaseline />

    <MuiThemeProvider theme={theme}>
      <StylesProvider generateClassName={generateClassName} injectFirst>
        <SnackbarProvider
          maxSnack={5}
          classes={{
            variantSuccess: "dpe-snackbar-success"
          }}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
        >
          <App />
        </SnackbarProvider>
      </StylesProvider>
    </MuiThemeProvider>
  </StoreContext.Provider>,
  document.getElementById("deskpad_root")
);
